module.exports = __webpack_public_path__ + "img/CameraHead_breadboard.17f56d39.png";